import styled from "styled-components";
import { theme } from "styles/mui-config";
import { InputBase } from "@mui/material";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

export const StyledPaper = styled(Paper)`
  width: 100%;
  height: auto;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  padding-right: 10px;
  padding-left: 10px;
  position: sticky;
  top: 20px;
  margin-bottom: 110px;
  @media (max-width: 900px) {
    position: static;
    top: 0;
    margin-bottom: 40px;
  }
`;

export const StyledTitleFilteBox = styled.p`
  color: #004a5e;
  padding-top: 20px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 6px;
`;

export const StyledTitleBorderDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;

export const StyledTitleBorder = styled.div`
  width: 15%;
  border: 2px solid #004a5e;
  border-radius: 5px;
`;

export const StyledCategorieDiv = styled.div`
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  justify-content: right;
  align-items: center;
  padding-bottom: 5px;
  color: #4f4f4f;
  transition: 0.1s;

  &:hover {
    color: #000 !important;
  }
`;

export const StyledCategoryTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  justify-contact: end;
  align-items: center;
`;

export const StyledCheckbox = styled(Paper)`
  width: 100%;
  height: auto;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
`;

export const StyledProductDiv = styled(Paper)`
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px !important;
  width: 100%;
  padding: 10px;
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 4px;
`;

export const StyledProductData = styled.div`
  position: relative;
`;

export const StyledProductImgDiv = styled.div`
  border-radius: 4px;
  width: 80px !important;
  height: 80px !important;
  max-width: 100%;
`;

export const StyledProductImg = styled.img`
  border-radius: 4px;
`;

export const StyledProductTitle = styled.p`
  font-size: 15px;
  font-weight: 300;
  line-height: 25px;
  color: #41464f;
  overflow: hidden;
  text-align: right;
  margin-top: 0px;
  margin-bottom: 0;
  position: absolute;
  top: 0;
  right: 90px;
`;

export const StyledColorsProduct = styled.div`
  width: 100px;
  height: 19px;
  overflow: hidden;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content:center;
  & > span{
    display:inline-block;
    width:10px;
    height:10px;
    border-radius:100%;
    border 1px solid gray;
    margin:5px;
  }
`;

export const StyledProductPrice = styled.p`
  margin: 0;
  text-align: left;
  color: #41464f;
  font-size: 17px;
  direction: rtl;
  position: absolute;
  bottom: 3px;
  left: 0;
`;

export const StyledProductBeforePrice = styled.p`
  margin: 0;
  text-align: left;
  font-size: 17px;
  direction: rtl;
  text-decoration: line-through !important;
  color: #bdc0c4;
`;

export const StyledSlideProductDiscount = styled.div`
  position: absolute;
  width: 42px;
  height: 25px;
  border-radius: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  background-color: #f1394e !important;
`;

////////////////// Search /////////////////////
export const SearchBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
`;

//////////////////////////////////////////
export const StyledInputBase = styled(InputBase)`
  color: inherit;
  width: 100% !important;
  & .MuiInputBase-input {
    color: gray !important;
    transition: 0.3s;
    width: 100% !important;
    text-align: right;
    height: 100%;
    padding: 0;
    padding-right: 0px;
    padding-right: 16px;
    &:focus {
      background: ${theme.palette.primary.light} !important;
    }
  }
`;

//////////////////////////////////
export const StyledSearch = styled.div`
  min-width: 250px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100% !important;
  background: white;
  transition: 0.3s;
  height: 55px;
  margin: 10px;
  margin-top: 0;
  margin-left: 0;
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 2px solid ${theme.palette.primary.main};
  z-index: 2;
`;

//////////////////////////////////
export const SearchBox = styled.div`
  position: relative;
  width: 100% !important;
  height: 100% !important;
  // padding: 10px;
`;

//////////////////////////////////
export const StyledProductBox = styled.div`
  padding-top: 60px;
  width: 100% !important;
  height: 100% !important;
  overflow-y: auto;
  overflow-x: hidden;
  direction: rtl;
  padding-left: 10px;
  padding-right: 10px;
`;
